export function setFocusToError(){
  setTimeout(()=>{
    if(document.querySelector('.inValid')){
      let y = [].slice.call(document.querySelectorAll(".inValid"));
      const z = y.filter(x => x.getBoundingClientRect().width > 0);
      if(z.length > 0){
        window.scroll({
          top: ((z[0].getBoundingClientRect().top + window.scrollY) - 200),
          behavior: 'smooth'
        });
      }
    }
  });
}

export function setFocusToErrorNew() {
  const scrollToError = () => {
    const errors = Array.from(document.querySelectorAll(".sceInputError"))
      .filter(el => el.getBoundingClientRect().width > 0);
    if (errors.length > 0) {
      window.scroll({
        top: errors[0].getBoundingClientRect().top + window.scrollY - 200,
        behavior: 'smooth'
      });
    }
  };

  requestAnimationFrame(() => {
    setTimeout(scrollToError, 0); // fallback in case layout isn't ready
  });
}

export function scrollToTopMac() {
  // let alertBanner = '';
  // const alertError = document.getElementById('error-message-alert');
  // const alertWarning = document.getElementById('warning-message-alert');
  // const isAlertPresent = alertError || alertWarning;
  // const isAlertBannerVisible = isAlertPresent && isAlertPresent.offsetParent !== null;

  // if (alertError && alertWarning) {
  //   alertBanner = alertError.offsetHeight + alertWarning.offsetHeight;
  // } else if (alertError && !alertWarning) {
  //   alertBanner = alertError.offsetHeight;
  // } else if (!alertError && alertWarning) {
  //   alertBanner = alertWarning.offsetHeight;
  // }
  let alertBanner = document.getElementById('alert-accordion');
  const isAlertBannerVisible = alertBanner && alertBanner.offsetParent !== null;
  requestAnimationFrame(() => {
    const el = document.scrollingElement || document.documentElement;
    // const alertBannerHeight = alertBanner ? alertBanner : 0;
    const targetScrollTop = isAlertBannerVisible ? alertBanner.offsetHeight : 0;
    el.scrollTo({ top: targetScrollTop, behavior: 'smooth' });
    setTimeout(() => {
      if (window.scrollY > targetScrollTop) {
        window.scrollTo(0, targetScrollTop); // force scroll to correct position
      }
    }, 100);
  });
}

export function scrollToDynamicPosition(targetScrollTop) {
  let alertBanner = document.getElementById('alert-accordion');
  const isAlertBannerVisible = alertBanner && alertBanner.offsetParent !== null;
  requestAnimationFrame(() => {
    const el = document.scrollingElement || document.documentElement;
     const updatedTargetScrollTop = isAlertBannerVisible ? targetScrollTop + alertBanner.offsetHeight : targetScrollTop;
    el.scrollTo({ top: updatedTargetScrollTop, behavior: 'smooth' });
    setTimeout(() => {
      if (window.scrollY > updatedTargetScrollTop) {
        window.scrollTo(0, updatedTargetScrollTop); // force scroll to correct position
      }
    }, 100);
  });
}
export function checkStreetValue(bopoxnumber, streetvalue) {
  if (bopoxnumber && streetvalue === 'BOX') {
    return '';}
  else { return streetvalue; }
}

export function postLookupLoginConfiguration(customerAccountData) {
  let accountData = customerAccountData.contractDetailsResponse.results;
  let linkedAccounts = [], selectBoxData = [];
  let bpData={};
  let numberContracts=0;
  accountData.forEach((contractDetails) => {
    let businessPartnerNavDetails = contractDetails.buisnessPartnerNavigation.results;
    businessPartnerNavDetails.forEach((bpDetails) => {
      bpData = bpDetails;
      let contractAccountNavDetails = bpDetails.contractAccountNavigation.results;
      contractAccountNavDetails.forEach((contractAccnts, index) => {
        contractAccnts.ContractNavigation.results.forEach((contractAccntDetails, index) => {
          numberContracts = numberContracts + 1;
          let linkedAccountObj = {};
          let selectedObj = {};
          selectedObj.value = contractAccntDetails.contractNumber;
          selectedObj.name = contractAccntDetails.contractNumber+ ' - ' + contractAccntDetails.houseNumber.trim() + ' ' + contractAccntDetails.serviceStreetAddress.trim() + ' ' + contractAccntDetails.unitNumber.trim() + ' ' + contractAccntDetails.city.trim() + ', ' +
              contractAccntDetails.state.trim() + ' ' + contractAccntDetails.zipCode;
          selectBoxData.push(selectedObj);
          linkedAccountObj.customerAccountNumber = contractAccnts.contractAccountNumber;
          linkedAccountObj.contractNumber = contractAccntDetails.contractNumber;
          linkedAccountObj.email = contractAccntDetails.customerEmailId || '';
          linkedAccountObj.phone = (contractAccntDetails.primPhone && contractAccntDetails.primPhone.phoneNumber) || '';
          linkedAccountObj.extn = (contractAccntDetails.primPhone && contractAccntDetails.primPhone.phoneExtNumber) || '';
          linkedAccountObj.address = contractAccntDetails.serviceStreetAddress.trim() + ' ' + contractAccntDetails.city.trim() + ',' + ' ' + contractAccntDetails.state.trim() + ' ' + contractAccntDetails.zipCode;
          linkedAccountObj.sreetAddress = contractAccntDetails.serviceStreetAddress;
          linkedAccountObj.city = contractAccntDetails.city;
          linkedAccountObj.state = contractAccntDetails.state;
          linkedAccountObj.zipCode = contractAccntDetails.zipCode;
          linkedAccountObj.houseNumber = contractAccntDetails.houseNumber;
          linkedAccountObj.postBoxNumber = contractAccnts.postBoxNumber ? contractAccnts.postBoxNumber : '';
          linkedAccountObj.premiseNumber = contractAccntDetails.premiseNumber;
          linkedAccountObj.state = contractAccntDetails.state;
          linkedAccountObj.unitNumber = contractAccntDetails.unitNumber;
          linkedAccountObj.addressLine1 = contractAccntDetails.houseNumber.trim() + ' ' + contractAccntDetails.serviceStreetAddress.trim() + ' ' + contractAccntDetails.unitNumber.trim();
          linkedAccountObj.addressLine2 = contractAccntDetails.city.trim() + ', ' + contractAccntDetails.state.trim() + ' ' + contractAccntDetails.zipCode.trim();
          linkedAccountObj.rateCategory = contractAccntDetails.rateCategory;
          linkedAccountObj.contractAccountType = contractAccnts.contractAccountType;
          let bpDetailsZipCode = contractAccnts.zipCode.trim().split('-')[0];
          linkedAccountObj.mailingCity = contractAccnts.city.trim();
          linkedAccountObj.mailingState = contractAccnts.state.trim();
          linkedAccountObj.mailingZipCode = bpDetailsZipCode;
          linkedAccountObj.mailingHouseNumber = contractAccnts.houseNumber.trim();
          linkedAccountObj.mailingStreetAddress = checkStreetValue(contractAccnts.postBoxNumber, contractAccnts.contractAccountStreetAddress.trim());
          linkedAccountObj.mailingUnitNumber = contractAccnts.unitNumber.trim();
          linkedAccountObj.mailingAddressLine1 = contractAccnts.houseNumber.trim() + ' ' + checkStreetValue(contractAccnts.postBoxNumber, contractAccnts.contractAccountStreetAddress.trim()) + ' ' + contractAccnts.unitNumber.trim();
          linkedAccountObj.mailingAddressLine2 = contractAccnts.city.trim() + ', ' + contractAccnts.state.trim() + ' ' + bpDetailsZipCode;
          linkedAccountObj.mailingAddress = contractAccnts.houseNumber.trim() + ' ' + checkStreetValue(contractAccnts.postBoxNumber, contractAccnts.contractAccountStreetAddress.trim()) + ' ' + contractAccnts.unitNumber.trim() + ' ' + contractAccnts.city.trim() + ', ' + contractAccnts.state.trim() + ' ' + bpDetailsZipCode;
          let bpName = bpData.businessPartnerName.trim();
          if (bpName.includes(',')) {
            linkedAccountObj.firstName = bpName.split(",")[1] || '';
            linkedAccountObj.middleName = '';
            linkedAccountObj.lastName = (bpName.split(',')[0]) || '';
          } else {
            linkedAccountObj.firstName = bpName;
            linkedAccountObj.middleName = '';
            linkedAccountObj.lastName = '';
          }
          linkedAccountObj.serviceAddress = linkedAccountObj.address;
          let bpResponse = {
            numberOfContractAccounts: bpData.numberOfContractAccounts,
            numberOfContract: bpData.numberOfContract,
            businessPartnerName: bpData.businessPartnerName,
            relationship: bpData.relationship,
            buisnessPartnerNumber: bpData.buisnessPartnerNumber,
          };
          linkedAccountObj.bpResponse = bpResponse;
          linkedAccounts.push(linkedAccountObj);
          //}
        });
      });
    });
  });
  let sendData = {
    linkedAccounts,
    selectBoxData,
    bpData,
    numberContracts
  };
  app.appService.setSessionstorage('lookUpTurnOffData', sendData);
  app.appUtil.navigateTo(app.appUtil.getAppRoutes().MOVECENTER.TURNOFF_LOGIN_NAVIGATION);
}

export function postLookUpLoginTransferConfig(customerAccountData) {
  let accountData = customerAccountData.contractDetailsResponse.results;
  let linkedAccounts = [], selectBoxData = [];
  let bpData = {}, numberContracts = 0;
  accountData.forEach((contractDetails) => {
    let businessPartnerNavDetails = contractDetails.buisnessPartnerNavigation.results;
    businessPartnerNavDetails.forEach((bpDetails) => {
      bpData = bpDetails;
      let contractAccountNavDetails = bpDetails.contractAccountNavigation.results;
      contractAccountNavDetails.forEach((contractAccnts, index) => {
        contractAccnts.ContractNavigation.results.forEach((contractAccntDetails, index) => {
          numberContracts = numberContracts + 1;
          let linkedAccountObj = {};
          let selectedObj = {};
          selectedObj.value = contractAccntDetails.contractNumber;
          selectedObj.name = contractAccntDetails.contractNumber + ' - ' + contractAccntDetails.houseNumber.trim() + ' ' + contractAccntDetails.serviceStreetAddress.trim() + ' ' + contractAccntDetails.unitNumber.trim() + ' ' + contractAccntDetails.city.trim() + ',' +
              contractAccntDetails.state.trim() + ' ' + contractAccntDetails.zipCode;
          selectBoxData.push(selectedObj);
          linkedAccountObj.customerAccountNumber = contractAccnts.contractAccountNumber;
          linkedAccountObj.contractNumber = contractAccntDetails.contractNumber;
          linkedAccountObj.email = contractAccntDetails.customerEmailId || '';
          linkedAccountObj.phone = (contractAccntDetails.primPhone && contractAccntDetails.primPhone.phoneNumber) || '';
          linkedAccountObj.extn = (contractAccntDetails.primPhone && contractAccntDetails.primPhone.phoneExtNumber) || '';
          linkedAccountObj.address = contractAccntDetails.serviceStreetAddress.trim() + ' ' + contractAccntDetails.city.trim() + ',' + ' ' + contractAccntDetails.state.trim() + ' ' + contractAccntDetails.zipCode;
          linkedAccountObj.sreetAddress = contractAccntDetails.serviceStreetAddress;
          linkedAccountObj.rateCategory = contractAccntDetails.rateCategory;
          linkedAccountObj.city = contractAccntDetails.city;
          linkedAccountObj.state = contractAccntDetails.state;
          linkedAccountObj.zipCode = contractAccntDetails.zipCode;
          linkedAccountObj.houseNumber = contractAccntDetails.houseNumber;
          linkedAccountObj.postBoxNumber = contractAccnts.postBoxNumber ? contractAccnts.postBoxNumber : '';
          linkedAccountObj.premiseNumber = contractAccntDetails.premiseNumber;
          linkedAccountObj.state = contractAccntDetails.state;
          linkedAccountObj.unitNumber = contractAccntDetails.unitNumber;
          linkedAccountObj.addressLine1 = contractAccntDetails.houseNumber.trim() + ' ' + contractAccntDetails.serviceStreetAddress.trim() + ' ' + contractAccntDetails.unitNumber.trim();
          linkedAccountObj.addressLine2 = contractAccntDetails.city.trim() + ', ' + contractAccntDetails.state.trim() + ' ' + contractAccntDetails.zipCode.trim();
          let bpDetailsZipCode = contractAccnts.zipCode.trim().split('-')[0];
          linkedAccountObj.mailingCity = contractAccnts.city.trim();
          linkedAccountObj.mailingState = contractAccnts.state.trim();
          linkedAccountObj.mailingZipCode = bpDetailsZipCode;
          linkedAccountObj.mailingHouseNumber = contractAccnts.houseNumber.trim();
          linkedAccountObj.mailingStreetAddress = checkStreetValue(contractAccnts.postBoxNumber, contractAccnts.contractAccountStreetAddress.trim());
          linkedAccountObj.mailingUnitNumber = contractAccnts.unitNumber.trim();
          linkedAccountObj.mailingAddressLine1 = contractAccnts.houseNumber.trim() + ' ' + checkStreetValue(contractAccnts.postBoxNumber, contractAccnts.contractAccountStreetAddress.trim()) + ' ' + contractAccnts.unitNumber.trim();
          linkedAccountObj.mailingAddressLine2 = contractAccnts.city.trim() + ', ' + contractAccnts.state.trim() + ' ' + bpDetailsZipCode;
          linkedAccountObj.mailingAddress = contractAccnts.houseNumber.trim() + ' ' + checkStreetValue(contractAccnts.postBoxNumber, contractAccnts.contractAccountStreetAddress.trim()) + ' ' + contractAccnts.unitNumber.trim()  + ' ' + contractAccnts.city.trim() + ', ' + contractAccnts.state.trim() + ' ' + bpDetailsZipCode;
          let bpName = bpData.businessPartnerName.trim();
          if (bpName.includes(',')) {
            linkedAccountObj.firstName = bpName.split(",")[1] || '';
            linkedAccountObj.middleName = '';
            linkedAccountObj.lastName = (bpName.split(',')[0]) || '';
          } else {
            linkedAccountObj.firstName = bpName;
            linkedAccountObj.middleName = '';
            linkedAccountObj.lastName = '';
          }
          linkedAccountObj.serviceAddress = linkedAccountObj.address;
          let bpResponse = {
            numberOfContractAccounts: bpData.numberOfContractAccounts,
            numberOfContract: bpData.numberOfContract,
            businessPartnerName: bpData.businessPartnerName,
            relationship: bpData.relationship,
            buisnessPartnerNumber: bpData.buisnessPartnerNumber,
          };
          linkedAccountObj.bpResponse = bpResponse;
          linkedAccountObj.custAccntDetails = contractAccnts;
          linkedAccounts.push(linkedAccountObj);
          //}
        });
      });
    });
  });
  let sendData = {
    linkedAccounts,
    selectBoxData,
    bpData,
    numberContracts
  };
  app.appService.setSessionstorage('lookUpTransferData', sendData);
  app.appUtil.navigateTo(app.appUtil.getAppRoutes().MOVECENTER.TRANSFER_LOGIN_NAVIGATION);
}